import * as React from 'react'

export const CircleCheckIcon = ({
  className,
  fill = 'none',
}: {
  className?: string
  fill: string
}) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 14 13"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill={fill}
    >
      <path
        d="M7 13C4.84375 13 2.875 11.875 1.79688 10C0.71875 8.14844 0.71875 5.875 1.79688 4C2.875 2.14844 4.84375 1 7 1C9.13281 1 11.1016 2.14844 12.1797 4C13.2578 5.875 13.2578 8.14844 12.1797 10C11.1016 11.875 9.13281 13 7 13ZM9.64844 5.89844H9.625C9.85938 5.6875 9.85938 5.33594 9.625 5.10156C9.41406 4.89062 9.0625 4.89062 8.85156 5.10156L6.25 7.72656L5.14844 6.625C4.91406 6.39062 4.5625 6.39062 4.35156 6.625C4.11719 6.83594 4.11719 7.1875 4.35156 7.39844L5.85156 8.89844C6.0625 9.13281 6.41406 9.13281 6.64844 8.89844L9.64844 5.89844Z"
        fill="currentColor"
      />
    </svg>
  )
}
